<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.searchKey"  placeholder="广告位编号/名称" />
      <search-slot-Type-select v-model="tableParams.slotTypeId" />
      <search-channel-app-select v-model="tableParams.appId" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="toPage()" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <span v-if="v.field === 'isEnable'">{{ scope.row.isEnable  === 0 ? '正常' : '禁用' }}</span>
              <span v-else-if="v.field === 'slotTypeId'">{{ slotTypeMap(scope.row.slotTypeId) }}</span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="100">
            <template v-slot="scope" align="center">
              <el-button @click="toPage(scope.row.slotId)" type="primary" size="mini">编辑</el-button>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import SearchChannelAppSelect from '@/components/SearchChannelAppSelect'
import TableColumn from '@/components/TableColumn'

import initTableMixin from '@/mixins/initTable'

import slotTypeList from '@/const/slot-type'

export default {
  name: 'advertiseChannel',
  components: {
    SearchSlotTypeSelect,
    SearchChannelAppSelect,
    TableColumn
  },
  mixins: [initTableMixin],
  data () {
    return {
      test: undefined,
      columns: [
        { field: 'slotId', title: '广告位编号' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'slotTypeId', title: '广告位类型' },
        { field: 'isEnable', title: '广告位状态' },
        { field: 'appId', title: '应用编号' }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/slot/channel/list'
      return true
    },
    slotTypeMap (slotTypeId) {
      for (let i = 0; i < slotTypeList.length; i++) {
        if (slotTypeList[i].value === slotTypeId) {
          return slotTypeList[i].label
        }
      }
      return slotTypeId
    },
    toPage (slotId) {
      if (!slotId) {
        this.$router.push({ path: 'add' })
      } else {
        this.$router.push({ path: 'update', query: { slotId: slotId } })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}
.el-pagination {
  text-align: right;
}
</style>
